import React from "react";
import { ExerciseBase, CategoryType, ExerciseType } from "../modules/exercises.types";

type ExerciseCardProps = {
  exercise: ExerciseBase;
};

const categoryLabels: Record<CategoryType, string> = {
  [CategoryType.COMPRENDRE]: "Comprendre",
  [CategoryType.PRATIQUER]: "Pratiquer",
  [CategoryType.EXPLORER]: "Explorer",
};

const typeLabels: Record<ExerciseType, string> = {
  [ExerciseType.MICRO_COURS]: "Micro-cours",
  [ExerciseType.QUIZ]: "Quiz",
  [ExerciseType.ANALYSE_RAPIDE]: "Analyse rapide",
  [ExerciseType.COGNITIF]: "Cognitif",
  [ExerciseType.DEFIS_REELS]: "Défis réels",
  [ExerciseType.SIMULATION]: "Simulation",
  [ExerciseType.ILLUSION]: "Illusion",
  [ExerciseType.HISTOIRE]: "Histoire",
  [ExerciseType.CREATIVITE]: "Créativité",
};

export function ExerciseCard({ exercise }: ExerciseCardProps) {
  const { title, description, level, estimatedDuration, category, type } = exercise;

  return (
    <div className="rounded-xl border shadow-sm p-4 bg-white/90 dark:bg-slate-900 dark:border-slate-700 transition hover:-translate-y-0.5 hover:shadow-md">
      <div className="flex items-center justify-between gap-2 mb-2">
        <span className="text-[11px] inline-flex items-center gap-1 rounded-full px-2 py-1 border border-slate-200 bg-slate-50 text-slate-600 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200">
          {categoryLabels[category]}
        </span>
        <span className="text-[11px] inline-flex items-center gap-1 rounded-full px-2 py-1 border border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/60 dark:bg-blue-900/40 dark:text-blue-100">
          {typeLabels[type]}
        </span>
      </div>
      <h3 className="text-lg font-semibold text-slate-900 dark:text-slate-100">{title}</h3>
      <p className="text-sm text-slate-600 dark:text-slate-300 mt-1">{description}</p>

      <div className="flex flex-wrap gap-2 text-[11px] text-slate-500 dark:text-slate-300 mt-3">
        {level && (
          <span className="inline-flex items-center rounded-full px-2 py-1 border border-slate-200 bg-white dark:border-slate-600 dark:bg-slate-800">
            Niveau : {level}
          </span>
        )}
        {typeof estimatedDuration === "number" && (
          <span className="inline-flex items-center rounded-full px-2 py-1 border border-slate-200 bg-white dark:border-slate-600 dark:bg-slate-800">
            {estimatedDuration} min
          </span>
        )}
      </div>
    </div>
  );
}
